export const editorNodeIdClass = (elementId: string) => `vp-editor-id-${elementId.replace(/[^a-zA-Z0-9_-]/g, '_')}`;
